import { useQuery } from '@biletiniz/apollo';
import { VISA_PRICES_QUERY } from './gql';

export const useVisaPrices = visaProviderType => {
  const visaPricesQuery = useQuery(VISA_PRICES_QUERY, {
    variables: {
      visaProviderType,
    },
    skip: !visaProviderType,
    fetchPolicy: 'no-cache',
  });
  return {
    visaPrices: visaPricesQuery?.data?.visaPrices,
    loadVisaPricesError: visaPricesQuery?.error?.message,
    isLoadingVisaPrices: visaPricesQuery.loading,
  };
};
